import { CustomFieldRedactMethod } from './../../enums/settings/customField/CustomFieldRedactMethod';

export const CustomFieldRedactMethodLabel = new Map<number, string>([
    [CustomFieldRedactMethod.MaskNothing, "Mask nothing"],
    [CustomFieldRedactMethod.MaskAllCharacters, "Mask all characters"],
    [CustomFieldRedactMethod.ShowLastFourCharacters, "Show last four characters"],

]);